import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../Icon/Icon";
import { LanguageSelector } from "../../SharedComponents/LanguageSelector/LanguageSelector";
import { EflowLoginFooter } from "../EflowLoginFooter/EflowLoginFooter";
import "./LoginContainer.css";

export const LoginContainer = ({ title = "", children }) => {
  const { t } = useTranslation();
  return (
    <div className="LoginContainer">
      <div className="LoginContainer__top-gradient" />
      <div className="LoginContainer__language">
        <LanguageSelector />
      </div>
      <div className="LoginContainer__logo">
        <div className="LoginContainer__logo-background">
          <Icon name="iconLock" width={11} />
        </div>
      </div>
      <div className="LoginContainer__content">
        <div className="LoginContainer__login">
          {title && <div className="LoginContainer__text">{t(title)}</div>}
        </div>
        {children}
        <EflowLoginFooter />
      </div>
    </div>
  );
};
